<script setup lang="ts">
import { ref } from 'vue'

import { Button, Popover } from '@collector/shared-ui'
import { useAuth } from '@desktop/globalState/userAuth/useAuth'

// state
const isPopoverOpen = ref(false)

// composable
const { logOut } = useAuth()

// methods
function hidePopover(): void {
  isPopoverOpen.value = false
}

function handleLogout(): void {
  logOut()
  hidePopover()
}
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    :withCloseIcon="false"
    :trigger="{
      asChild: true,
    }"
  >
    <template #trigger>
      <Button
        :class="{
          'bg-neutral-light-0 border-neutral-light-0': isPopoverOpen,
          'border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3':
            !isPopoverOpen,
        }"
        icon="right-from-bracket"
        size="sm"
        square
      />
    </template>

    <template #content>
      <div class="text-xs font-bold">
        <div class="text-neutral-dark-0 pb-2 text-center">
          Do you want to log out?
        </div>
        <div class="flex gap-x-4">
          <Button
            class="text-neutral-dark-0 border-neutral-dark-0 hover:border-neutral-dark-2 hover:bg-neutral-light-4"
            size="sm"
            :square="false"
            width="full"
            @click="hidePopover()"
          >
            No
          </Button>
          <Button
            class="text-neutral-light-10 bg-success-2 border-success-2 hover:border-success-4 hover:bg-success-4"
            size="sm"
            :square="false"
            width="full"
            @click="handleLogout()"
          >
            Yes
          </Button>
        </div>
      </div>
    </template>
  </Popover>
</template>
